
import React, { useEffect, useState, Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import ColorTextBox from '../common/ColorTextBox';

let resolve;

const classNames = mergeStyleSets({
    choiceRoot: {
        width: 400
    },
    innerContent: {
        paddingLeft: 26
    }
});

const ChoiceSet = (props) => {

    const [value, setValue] = useState(
        (props.categoryItems && (props.categoryItems.length > 0))
            ? props.categoryItems[0].item_name
            : ''
    );

    useEffect(() => {
        if (props.onChangeCategoryItem) {
            props.onChangeCategoryItem(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChangeItem = (event, option) => {
        setValue(option.key);
    }

    const getOptions = () => {
        return (props.categoryItems || []).map(item => {
            return {key: item.item_name, text: item.item_title}
        });
    }

    const isDisabled = () => {
        return (
            !(props.categoryItems && (props.categoryItems.length > 0)) ||
            (props.originalProps ? !props.originalProps.checked : false)
        );
    }

    return (
        <div className={classNames.choiceRoot}>
            {props.render(props.originalProps)}
            <div className={classNames.innerContent}>
                <ComboBox
                    label="Položka kategorie"
                    options={getOptions()}
                    selectedKey={value}
                    onChange={handleChangeItem}
                    disabled={isDisabled()}
                />
            </div>
        </div>
    );
}

const ChoiceAddSet = (props) => {

    const [title, setTitle] = useState('');
    const [color, setColor] = useState('255 255 255');

    useEffect(() => {
        if (props.onChangeCategoryItemColor) {
            props.onChangeCategoryItemColor(color);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [color]);

    useEffect(() => {
        if (props.onChangeCategoryItemTitle) {
            props.onChangeCategoryItemTitle(title);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title]);

    const handleChangeColor = (value) => {
        setColor(value);
    }

    const handleChangeTitle = (event) => {
        setTitle(event.target.value);
    }

    return (
        <div className={classNames.choiceRoot}>
            {props.render(props.originalProps)}
            <div className={classNames.innerContent}>
                <TextField
                    label="Název nové položky kategorie"
                    value={title}
                    onChange={handleChangeTitle}
                    disabled={props.originalProps ? !props.originalProps.checked : false}
                />
                <ColorTextBox
                    label="Barva nové položky kategorie"
                    value={color}
                    onChange={handleChangeColor}
                    disabled={props.originalProps ? !props.originalProps.checked : false}
                />
            </div>
        </div>
    );
}

const DialogContent = (props) => {

    const [value, setValue] = useState(props.categoryItems ? 'SET' : 'ADDSET');

    useEffect(() => {
        if (props.onChangeChoice) {
            props.onChangeChoice(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const onChange = (event, option) => {
        setValue(option.key);
    }

    const handleChangeCategoryItem = (categoryItemName) => {
        if (props.onChangeCategoryItem) {
            props.onChangeCategoryItem(categoryItemName);
        }
    }

    const handleChangeCategoryItemColor = (categoryItemColor) => {
        if (props.onChangeCategoryItemColor) {
            props.onChangeCategoryItemColor(categoryItemColor);
        }
    }

    const handleChangeCategoryItemTitle = (categoryItemTitle) => {
        if (props.onChangeCategoryItemTitle) {
            props.onChangeCategoryItemTitle(categoryItemTitle);
        }
    }

    return (
        <ChoiceGroup
            selectedKey={value}
            onChange={onChange}
            options={[
                {
                    key: 'SET',
                    text: 'Zařazení vybraných parcel do kategorie',
                    disabled: !props.categoryItems,
                    onRenderField: (renderProps, render) => {
                        return (
                            <ChoiceSet
                                categoryItems={props.categoryItems}
                                originalProps={renderProps}
                                render={render}
                                onChangeCategoryItem={handleChangeCategoryItem}
                            />
                        );
                    }
                },
                {
                    key: 'ADDSET',
                    text: 'Zařazení vybraných parcel do nové kategorie',
                    onRenderField: (renderProps, render) => {
                        return (
                            <ChoiceAddSet
                                originalProps={renderProps}
                                render={render}
                                onChangeCategoryItemColor={handleChangeCategoryItemColor}
                                onChangeCategoryItemTitle={handleChangeCategoryItemTitle}
                            />
                        );
                    }
                },
                {
                    key: 'REMOVE',
                    text: 'Vybraným parcelám odstranit kategorii'
                }
            ]}
        />
    )
}

class DialogSetCategoryItem extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogSetCategoryItem />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            categoryItem: null,
            categoryItems: [],
            categoryItemColor: '',
            categoryItemTitle: ''
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                operation: this.state.operation,
                categoryItem: this.state.categoryItem,
                categoryItemColor: this.state.categoryItemColor,
                categoryItemTitle: this.state.categoryItemTitle
            });
        }
    }

    handleChangeChoice = (operation) => {
        this.setState({
            operation: operation
        });
    }

    handleChangeCategoryItem = (categoryItem) => {
        this.setState({
            categoryItem: categoryItem
        });
    }

    handleChangeCategoryItemColor = (categoryItemColor) => {
        this.setState({
            categoryItemColor: categoryItemColor
        });
    }

    handleChangeCategoryItemTitle = (categoryItemTitle) => {
        this.setState({
            categoryItemTitle: categoryItemTitle
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Nastavení kategorie pro vybrané parcely"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContent
                        categoryItems={this.state.categoryItems}
                        onChangeChoice={this.handleChangeChoice}
                        onChangeCategoryItem={this.handleChangeCategoryItem}
                        onChangeCategoryItemColor={this.handleChangeCategoryItemColor}
                        onChangeCategoryItemTitle={this.handleChangeCategoryItemTitle}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Nastavit" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(categoryItems) {
        this.setState({
            hidden: false,
            operation: '',
            categoryItem: null,
            categoryItemColor: '',
            categoryItemTitle: '',
            categoryItems: categoryItems,
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogSetCategoryItem.create();
